import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { SparklesIcon, UsersIcon, ScissorsIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const items = [{
  icon: SparklesIcon,
  label: '365 ideas',
  color: '#F6C453'
}, {
  icon: UsersIcon,
  label: '4–10 años',
  color: '#6CBBD5'
}, {
  icon: ScissorsIcon,
  label: 'Materiales sencillos',
  color: '#F27C70'
}, {
  icon: DownloadIcon,
  label: 'Acceso inmediato',
  color: '#2D8C5A'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días',
  color: '#F3A340'
}];
export function TrustStrip() {
  const reduce = useReducedMotion();
  return <section className="w-full border-y border-navy/10 bg-white" aria-label="Señales de confianza" data-id="element-354" data-mp="1wdeqdx4g0ju5">
      <Reveal className="mx-auto flex max-w-content flex-wrap items-center justify-center gap-x-7 gap-y-4 px-5 py-5 sm:px-8" data-id="element-355" data-mp="3usiy2kjmi2ly">
        {items.map(({
        icon: Icon,
        label,
        color
      }, i) => <span key={label} className="flex items-center gap-2" data-id="element-356" data-mp="3ms1ovz7sz0ou" data-mpi={i}>
            <motion.span className="flex h-8 w-8 items-center justify-center rounded-xl" style={{
          backgroundColor: `${color}26`
        }} animate={reduce ? undefined : {
          y: [0, -4, 0]
        }} transition={{
          duration: 3.4,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: i * 0.25
        }} data-id="element-357" data-mp="3muxodrzatxfe">
              <Icon className="h-4 w-4" style={{
            color
          }} aria-hidden="true" data-id="element-358" data-mp="ecrocvjka3j6" />
            </motion.span>
            <span className="font-sans text-xs font-medium text-ink sm:text-sm" data-id="element-359" data-mp="lmlzlot6x55">{label}</span>
          </span>)}
      </Reveal>
    </section>;
}